import React, { useState, useRef, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import Logop from './Logop';
import {Link} from "react-router-dom";
const Customcard = ({ title, img, text, moreInfo, linkTo }) => {
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [cardHeight, setCardHeight] = useState('auto');
  const cardRef = useRef();
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  useEffect(() => {
    if (showMoreInfo) {
      setCardHeight(`${cardRef.current.clientHeight}px`);
    } else {
      setCardHeight('auto');
    }
  }, [showMoreInfo]);

  const handleMouseEnter = () => {
    setShowMoreInfo(true);
    console.log ("show more info:",showMoreInfo )
  };

  const handleMouseLeave = () => {
    setShowMoreInfo(false);
    console.log ("show more info:",showMoreInfo )
  };



  
  return (
    <Card
      ref={cardRef}
      style={{ width: '18rem', position: 'relative', height: cardHeight,filter: "drop-shadow(1px 1px 2px black)" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Card.Img
        variant="top"
        src={img}
        style={{
          width: '10rem',
          marginLeft: '18%',
          marginTop: '1%',
          opacity: showMoreInfo ? 0.3 : 1,
          transition: 'opacity 0.3s',
          
          
        }}
      />
      <Card.Body style={{ opacity: showMoreInfo ? 0 : 1, transition: 'opacity 0.3s' }}>
        <Card.Title className='cardtitle'>{title}</Card.Title>
        <Card.Text>{text}</Card.Text>
{/*         <Button variant="primary">Go somewhere</Button> */}
      </Card.Body>
      <Card
              style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '18rem',
          display: showMoreInfo ? 'block' : 'none',
          zIndex: 1,
          opacity: showMoreInfo ? 1 : 0,
          transition: showMoreInfo ? 'opacity 0.3s' : 'opacity 0.3s',
          backgroundColor: '#7764727a', // Color hexadecimal con transparencia (ajusta los últimos dos dígitos para cambiar la opacidad)
          height: cardHeight,
   /*        border: "2px solid #776472", */
/*           filter: "drop-shadow(5px 5px 4px #7a4397)", */
          cursor:"pointer",
          animationName: "zoomIn",
          animationDuration: "0.5s",
          boxShadow: "inset 0 0 0 1px hsla(240, 4%, 85%, 0), 0 0 0 2px #255484, 0 0.3px 0.4px #C2FCF7,0 0.9px 1.5px #85BDBF, 0 3.5px 6px #C2FCF7"
          
        }}
      >
        <Card.Body>
          <Card.Title className="cardtitle"> {title} </Card.Title>
          <Card.Text>{moreInfo}</Card.Text>
          <Link to={linkTo} onClick={handleScrollToTop} >
  <Button variant="primary">Saber más</Button>
</Link>
        </Card.Body>
      </Card>
    </Card>
  );
};

export default Customcard;
